import { TierType } from 'global-services/constants/OhsObject';
import { OhsUser } from 'user/OhsUser';
import { getWorkplaceOptions } from 'user/OhsUserServices';

export default class OhsIncidentLtiFilterModels {
  currentWorkplace: string;

  targetTier: {
    _id: string;
    name: string;
    tier: TierType | string;
  };

  workplaces: string[] | string;

  sort: string;

  years: string[];

  yearOptions: string[];

  roles: string[];

  roleOptions: string[];

  tableSortKeyLists: {
    sortColAscDescOptions: { name: string; value: string }[];
  };

  constructor(user?: OhsUser) {
    this.tableSortKeyLists = {
      sortColAscDescOptions: [
        { name: 'Year: Newest to Oldest', value: '{ "key": "year", "order": -1 }' },
        { name: 'Year: Oldest to Newest', value: '{ "key": "year", "order": 1 }' },
        // { name: 'Created Date: Newest to Oldest', value: '{ "key": "_id", "order": -1 }' },
        //  { name: 'Created Date: Oldest to Newest', value: '{ "key": "_id", "order": 1 }' },
      ],
    };
    this.sort = '{ "key": "year", "order": -1 }';
    this.workplaces = [];
    this.currentWorkplace = '';

    this.targetTier = {
      _id: '',
      name: '',
      tier: '',
    };

    this.years = [];

    this.yearOptions = [];

    this.roles = [];

    this.roleOptions = [];

    if (user) {
      const getWorkplaceLists = getWorkplaceOptions(user.configs);
      const workplaceOptions = getWorkplaceLists.map((list: any) => list.id);
      this.workplaces = workplaceOptions;
    }
  }
}
